import React, { useEffect } from 'react';

import { SkinThemeProvider } from '../../shared/SkinThemeContext';
import SkinThemeService from '../../shared/services/SkinThemeService';
import { ThemeProvider } from '@mui/material/styles';
import useThemes from '../../shared/hooks/useThemes';

interface withThemingProps<T> {
  clientName: string;
  baseProps?: T;
}

const withTheming =
  <T extends object = any>(BaseComponent: (baseProps?: T) => JSX.Element) =>
  (props: withThemingProps<T>) => {
    const { skinTheme, muiTheme } = useThemes();

    useEffect(() => {
      const bodyStyle = document.body.style;
      document.body.style.backgroundColor =
        SkinThemeService.getThemeOptionValue(
          skinTheme,
          'auth',
          'backgroundColor'
        ) as string;
      document.body.style.backgroundImage = `url(${SkinThemeService.getAssetUrl(
        'auth',
        'backgroundImage'
      )})`;
      bodyStyle.backgroundSize = 'cover';
      bodyStyle.backgroundPosition = 'center';
      bodyStyle.backgroundRepeat = 'no-repeat';
      bodyStyle.backgroundAttachment = 'fixed';
    }, [skinTheme]);

    return (
      <ThemeProvider theme={muiTheme}>
        <SkinThemeProvider value={skinTheme}>
          <BaseComponent {...props.baseProps} />
        </SkinThemeProvider>
      </ThemeProvider>
    );
  };

export default withTheming;
